// **************************
// DOCUMENT TYPE
// **************************

export const getDocumentTypeList = (language) => {
    switch (language) {
        case 'pt':
            return DOCUMENT_TYPES;
        break;
        case 'en':
            return EN_DOCUMENT_TYPES;
        break;
        case 'es':
            return ES_DOCUMENT_TYPES;
        break;
        case 'fr':
            return FR_DOCUMENT_TYPES;
        break;
        default:
            break;
    }
}

// PT Version

export const DOCUMENT_TYPE_SWITZERLAND = { name: "Suíça", code: "Suíça" };
export const DOCUMENT_TYPE_UK = { name: "Reino Unido e Resto do Mundo", code: "Reino Unido e Resto do Mundo" };
export const DOCUMENT_TYPE_EU = { name: "União Europeia", code: "União Europeia" };

export const DOCUMENT_TYPES = [
    DOCUMENT_TYPE_SWITZERLAND,
    DOCUMENT_TYPE_UK,
    DOCUMENT_TYPE_EU
];

// EN Version

export const EN_DOCUMENT_TYPE_SWITZERLAND = { name: "Switzerland", code: "Suíça" };
export const EN_DOCUMENT_TYPE_UK = { name: "United Kingdom and Rest of the World", code: "Reino Unido e Resto do Mundo" };
export const EN_DOCUMENT_TYPE_EU = { name: "European Union", code: "União Europeia" };

export const EN_DOCUMENT_TYPES = [
    EN_DOCUMENT_TYPE_SWITZERLAND,
    EN_DOCUMENT_TYPE_UK,
    EN_DOCUMENT_TYPE_EU
];

// ES Version

export const ES_DOCUMENT_TYPE_SWITZERLAND = { name: "Suissa", code: "Suíça" };
export const ES_DOCUMENT_TYPE_UK = { name: "Reino Unido y resto del mundo", code: "Reino Unido e Resto do Mundo" };
export const ES_DOCUMENT_TYPE_EU = { name: "Unión Europea", code: "União Europeia" };

export const ES_DOCUMENT_TYPES = [
    ES_DOCUMENT_TYPE_SWITZERLAND,
    ES_DOCUMENT_TYPE_UK,
    ES_DOCUMENT_TYPE_EU
];

// FR Version

export const FR_DOCUMENT_TYPE_SWITZERLAND = { name: "Suisse", code: "Suíça" };
export const FR_DOCUMENT_TYPE_UK = { name: "Royaume-Uni et reste du monde", code: "Reino Unido e Resto do Mundo" };
export const FR_DOCUMENT_TYPE_EU = { name: "Union européenne", code: "União Europeia" };

export const FR_DOCUMENT_TYPES = [
    FR_DOCUMENT_TYPE_SWITZERLAND,
    FR_DOCUMENT_TYPE_UK,
    FR_DOCUMENT_TYPE_EU
];
